module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }